import { Avatar, Box, Heading, Button, ButtonGroup, Flex, Icon } from '@chakra-ui/react'
import React, {useState} from 'react'
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { FaRegComment } from 'react-icons/fa'
import {GiAnticlockwiseRotation} from "react-icons/gi";
import { tweet } from '../Types/Tweets'
import { TokenContext } from '../App';
import { useContext } from 'react';

import { Link } from 'react-router-dom';
import { baseUrl } from '../settings';

// @ts-ignore
const FeedCard = ({ tweeter: {first: firstName, last: lastName, image_url: avatar, username}, content: tweetContent, likes, posted_on, is_liked,id}) => {
    const name = `${firstName} ${lastName}`

    const {token, setToken} = useContext(TokenContext)
    const [isLiked, setIsLiked] = useState(is_liked)

    const handleLikeClick = () => {
        fetch(`${baseUrl}/tweet/like/${id}`, {
            method: 'POST',
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json'
            }
        })
        .then((res) => res.json())
        .then(() => setIsLiked(!isLiked))
    }

    return (
        <Box border="1px" borderColor="gray.200" marginX="1rem" marginY="1rem" paddingX="2rem" paddingY="2rem">
            <Flex direction="row">
                <Link to={`/profile/${username}`}>
                <Avatar name={name} src={avatar} marginRight="1.75rem"></Avatar>
                </Link> 
                <Flex direction="column">
                    <Flex>
                        <Link to={`/profile/${username}`}>
                            <Box>
                                <Heading as="h3" size="md" paddingRight="1rem">{name}</Heading>
                                <Box as="span">{"@" + username}</Box>
                            </Box>
                        </Link>
                    </Flex>
                    <Box>{tweetContent}</Box>
                    <ButtonGroup marginTop={"2rem"}>
                        <Link to={`/tweet/${id}`}><Button size="sm"><Icon as={FaRegComment}></Icon></Button></Link>
                        <Button onClick={handleLikeClick} size="sm">{isLiked ? <Icon as={AiFillHeart}></Icon>:<Icon as={AiOutlineHeart}></Icon>}</Button>
                    </ButtonGroup>
                </Flex>
            </Flex>
        </Box>
    )
}

export default FeedCard
